<div class="card">
    <div class="card-header text-primary"><h1 class="m-0 float-left">Servicios</h1><a routerLink="/categories/add" class="btn btn-primary btn-sm float-right">+ Nuevo</a></div>
    <div class="card-body">
        <table class="table table-hover table-bordered table-striped table-sm">
            <thead>
                <tr>
                    <th class="text-center">ID</th>
                    <th class="text-center">Nombre</th>
                    <th class="text-center">Valor</th>
                    <th class="text-center">Estado</th>
                    <th class="text-center">Creado</th>
                    <th class="text-center">Acciones</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of data">
                    <td class="text-center">{{ item._id }}</td>
                    <td class="text-center">{{ item.name }}</td>
                    <td class="text-center">{{ item.value }}</td>
                    <td class="text-center">{{ item.status ? 'Activo' : 'Inactivo' }}</td>
                    <td class="text-center">{{ item.createdAt }}</td>
                    <td class="text-center" nowrap>
                        <a class="btn btn-success btn-sm mx-1" routerLink="/categories/edit/{{item._id}}"><i class="fas fa-pen"></i></a>
                        <a class="btn btn-danger btn-sm mx-1" (click)="deleteData(item._id)"><i class="fas fa-trash"></i></a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>